var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5506 21.0297L22.4006 20.8494H22.1661L6.27237 20.8494C6.27215 20.8494 6.27193 20.8494 6.27171 20.8494C5.46749 20.847 4.69687 20.5264 4.12819 19.9577C3.5595 19.3891 3.23897 18.6184 3.23657 17.8142V5.87369C3.23956 5.06925 3.5606 4.29862 4.12964 3.72997C4.69873 3.16127 5.46965 2.84077 6.27415 2.83838H26.0348C26.8384 2.84196 27.6082 3.16295 28.1763 3.73144C28.7445 4.30004 29.0649 5.07016 29.0678 5.87398C29.0678 5.87416 29.0678 5.87434 29.0678 5.87452V17.8136C29.0678 17.8138 29.0678 17.814 29.0678 17.8142C29.0654 18.6185 28.7449 19.3891 28.1762 19.9577C27.6074 20.5266 26.8365 20.8471 26.032 20.8494L25.5334 20.8507V21.3494V24.6167L22.5506 21.0297Z",
    stroke: "#000000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4988 16.831C14.9064 16.7771 12.9752 16.6083 12.8773 15.9131C12.8969 15.5142 13.335 15.7614 13.5798 15.7418C14.8996 15.8772 16.233 15.7778 17.5181 15.4481C18.1431 15.2886 18.7451 15.05 19.3098 14.7382C19.4958 14.633 19.6647 14.4935 19.8507 14.4054C20.0464 14.2979 20.2592 14.225 20.4798 14.19C20.5775 14.1766 20.6771 14.1908 20.7672 14.231C20.8573 14.2712 20.9344 14.3359 20.9896 14.4177C21.0449 14.4994 21.0762 14.595 21.0799 14.6936C21.0837 14.7922 21.0598 14.8899 21.0109 14.9757C20.5605 15.7295 19.6941 16.0477 18.8692 16.3121C17.7934 16.7153 16.646 16.892 15.4988 16.831Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4956 10.9441C12.006 10.3298 12.0427 9.41922 12.29 8.7094C12.5372 7.99958 13.4453 7.65691 13.7586 8.56499C14.067 9.2895 13.7072 12.0211 12.4956 10.9441Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2411 11.1892C18.0785 10.92 18.4677 7.97791 19.4394 7.88001C20.2202 7.80168 20.3573 9.04265 20.345 9.59337C20.3769 10.2102 20.0587 11.4071 19.2411 11.1892Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.607 6.84218C11.4234 6.26698 12.7378 6.00019 13.1367 5.89984C13.477 5.86067 14.062 5.63794 14.1966 6.09565C14.2049 6.14597 14.2026 6.19746 14.1899 6.24685C14.1772 6.29624 14.1543 6.34244 14.1228 6.38251C14.0912 6.42257 14.0517 6.45563 14.0067 6.47957C13.9616 6.50351 13.9121 6.5178 13.8612 6.52154C13.6159 6.50471 13.3694 6.51704 13.1269 6.55826C12.7785 6.62284 12.4356 6.71449 12.1014 6.83239C11.9423 6.85932 11.7146 7.02821 11.607 6.84218Z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8053 6.84218C20.9913 6.26698 19.6769 6.00019 19.2779 5.89984C18.9353 5.86067 18.3527 5.63794 18.2157 6.09565C18.2077 6.14611 18.2104 6.19766 18.2234 6.24705C18.2364 6.29644 18.2595 6.3426 18.2912 6.38262C18.3229 6.42264 18.3626 6.45565 18.4078 6.47956C18.4529 6.50347 18.5025 6.51776 18.5534 6.52154C18.7988 6.50483 19.0453 6.51715 19.2877 6.55826C19.6355 6.62254 19.9776 6.7142 20.3109 6.83239C20.4699 6.85932 20.7 7.02821 20.8053 6.84218Z",
    fill: "#000000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7914_33",
    x: 0.618925,
    y: 0.220732,
    width: 31.0666,
    height: 27.8969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.05882
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7914_33"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7914_33",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.8e004fe82759dbde2f0de74c3031b1f7.svg";
export { ForwardRef as ReactComponent };